import React, { useEffect, useRef, useState } from "react";
import { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "./activityCategories.css";

import { AnimatePresence, motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "swiper/css";
import "swiper/css/scrollbar";
import Close from "../../../assets/icons/close";
import Left from "../../../assets/icons/left";
import Right from "../../../assets/icons/right";
import { openCategory, selectSingleCategory, showVideoModalActive, toggleCategoryDropdown } from "../../../redux/slices/activityCategories";
import { setDefaultSelectedActivity } from "../../../redux/slices/userActivity";
import Category from "./category";
import useOutsideAlerter from "../../../hooks/useOutsideAlerter";
import { fetchActivityCategories, fetchActivityTypes } from "../../../services/activity";
import { updateCategories } from "../../../redux/slices/activityCategories";
import { updateActivityTypes } from "../../../redux/slices/activityTypes";

export default function ActivityCategoriesModal() {
  const [swiper, setSwiper] = useState();

  const { categories, categoryDropdownActive } = useSelector((state) => state.activityCategories);
  const { activityTypes } = useSelector((state) => state.activityTypes);
  const { isLoggedIn } = useSelector((state) => state.user);
  const [iniCategories, setiniCat] = useState([]);

  useEffect(() => (categories ? setiniCat(categories.slice(0, 4)) : null), [categories]);

  const navigate = useNavigate();

  const navigationPrevRef = useRef(null);
  const navigationNextRef = useRef(null);
  const categoriesRef = useRef(null);
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(toggleCategoryDropdown({ active: categoryDropdownActive ? false : true }));
  };
  useOutsideAlerter(categoriesRef, handleClose);

  // only for mobile - shows types of categories of clicked category
  const handleOpen = (id) => {
    dispatch(openCategory({ id }));
  };

  const handleClick = (category, type) => {
    // if (category.name.toLowerCase().includes("video")) {
    //   dispatch(showVideoModalActive());
    // } else {
    // }
    // if (!isLoggedIn) return window.open(`/design?selectedActivityId=${type.id}`, "_blank");
    // navigate(`/design`);
    dispatch(selectSingleCategory({ id: category.id }));
    navigate(`/design?selectedActivityId=${type.id}`);
  };
  useEffect(() => {
    if (!categoryDropdownActive) return;
    setTimeout(() => {
      document.body.addEventListener("click", handleClose, { once: true });
    }, 100);
    return () => {
      document.body.removeEventListener("click", handleClose);
    };
  }, [categoryDropdownActive]);

  useEffect(() => {
    if (!categoryDropdownActive) return;

    if (categories.length >= 1) return;

    fetchActivityCategories((err, res) => {
      if (res !== null) {
        let categoryData = res.data;
        categoryData[0].isSelected = true;
        dispatch(updateCategories(categoryData));
      }
    });

    fetchActivityTypes((err, res) => {
      if (err) return;
      let tempTypes = res.data.map((type) => {
        return { ...type, isSelected: true, subtypes: [] };
      });
      dispatch(updateActivityTypes(tempTypes));
    });
  }, [categoryDropdownActive]);

  return (
    <AnimatePresence>
      {categoryDropdownActive && (
        <motion.div
          onClick={(e) => e.stopPropagation()}
          ref={categoriesRef}
          initial={{ y: "-100%" }}
          animate={{ y: "0%" }}
          exit={{ y: "-100%" }}
          transition={{ ease: "easeOut" }}
          className="activity_categories_modal_container"
        >
          <div className="activity_categories_modal">
            <div className="activity_categories_slider_container">
              <div className="activity_categories_slider_wrapper">
                <Swiper
                  className="activity_categories_dropdown_slider"
                  slidesPerView={5}
                  spaceBetween={0}
                  slidesPerGroup={2}
                  navigation={{
                    prevEl: navigationPrevRef.current,
                    nextEl: navigationNextRef.current,
                  }}
                  onBeforeInit={(swiper) => {
                    swiper.params.navigation.prevEl = navigationPrevRef.current;
                    swiper.params.navigation.nextEl = navigationNextRef.current;
                  }}
                  onSwiper={(swiper) => setSwiper(swiper)}
                  modules={[Navigation]}
                >
                  {categories.map((category, index) => {
                    return (
                      <SwiperSlide key={category.id} className="swiper_slide">
                        <div className="swiper_slide__category">
                          <div className="d-flex img-container">
                            <img src={category.thumbnail} />
                          </div>
                          <p className="swiper_slide__category-name"> {category.name} </p>
                          <div className="swiper_slide__types">
                            {activityTypes.map((type) =>
                              type.activity_category_id === category.id ? (
                                <p key={type.id} className="category_type" onClick={() => handleClick(category, type)}>
                                  {" "}
                                  {type.name}{" "}
                                </p>
                              ) : (
                                ""
                              )
                            )}
                          </div>
                        </div>
                      </SwiperSlide>
                    );
                  })}
                  {/* <div ref={navigationPrevRef} className='swiper__navigation_icon left'>
                             <Left />
                         </div>
                         <div ref={navigationNextRef} className='swiper__navigation_icon right'>
                             <Right />
                         </div> */}
                </Swiper>
                <div ref={navigationPrevRef} className="swiper__navigation_icon left">
                  <Left />
                </div>
                <div ref={navigationNextRef} className="swiper__navigation_icon right">
                  <Right />
                </div>
              </div>
            </div>

            {/* for mobile */}
            <div className="activity_categories_list_container">
              <div className="menu_header">
                <p>Create</p>
                <div onClick={handleClose} className="close_menu_btn">
                  <Close />
                </div>
              </div>
              <div className="activity_categories_list">
                {iniCategories.map((category) => {
                  return <Category key={category.id} {...category} handleClick={handleClick} handleOpen={handleOpen} />;
                })}
              </div>
              {iniCategories.length < categories.length ? (
                <p className="load_more" onClick={() => setiniCat(categories)}>
                  load more
                </p>
              ) : null}
            </div>

            <div className="close_text" onClick={handleClose}>
              close
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
